<div class="page-shell page-shell--canvas">
<div class="dc-wrapper">
    <div class="dc-layout">
      <div class="dc-section dc-sidebar">
        <div class="dc-section__header">
          <h2 class="dc-section__title">
            {{ "printCards.templatesTitle" | translate }}
          </h2>
        </div>
        <div class="dc-section__content">
          @if (selected) {
            <div
              class="dc-employee-picker-wrap"
              [hidden]="!employeePickerReady"
            >
              <app-digital-card-employee-picker
                [value]="previewEmployee"
                [templateContextId]="pickerTemplateContextId"
                (valueChange)="onPreviewEmployeeChange($event)"
                (initialSelectionResolved)="onEmployeePickerInitialResolved()"
              ></app-digital-card-employee-picker>
              @if (!listBusy && previewPageSizePresets.length > 0) {
                <mat-form-field appearance="outline" class="dc-page-size-select">
                  <mat-label>{{ "printCards.pageSize" | translate }}</mat-label>
                  <mat-select
                    [value]="previewPageSizePresetId"
                    (selectionChange)="onPreviewPageSizeChange($event.value)"
                  >
                    @for (preset of previewPageSizePresets; track preset.id) {
                      <mat-option [value]="preset.id">
                        {{ preset.labelKey | translate }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
            </div>
          }
          @if (!listBusy && canManageTemplates) {
            <button type="button" class="dc-add-card" (click)="createTemplate()">
              <mat-icon>add</mat-icon>
              <span>{{ "printCards.addTemplate" | translate }}</span>
            </button>
          }
          <div class="dc-list">
            @if (!listBusy) {
              @for (item of items; track item.printCardTemplateId) {
                <button
                  type="button"
                  class="dc-list-item"
                  [class.dc-list-item--selected]="isSelected(item)"
                  (click)="select(item)"
                >
                  <div class="dc-list-meta">
                    <div class="dc-list-name-row">
                      <span class="dc-list-name">{{ item.name }}</span>
                      @if (item.isPendingApproval) {
                        <span class="dc-list-pending">
                          <mat-icon>hourglass_empty</mat-icon>
                          {{ "printCards.pending.badge" | translate }}
                        </span>
                      } @else if (item.isActive) {
                        <span class="dc-list-active">
                          <mat-icon>check</mat-icon>
                          {{ "printCards.active.badge" | translate }}
                        </span>
                      } @else if (item.isPreview) {
                        <span class="dc-list-preview">
                          <mat-icon>visibility</mat-icon>
                          {{ "printCards.preview.badge" | translate }}
                        </span>
                      }
                    </div>
                    <span class="dc-list-type">
                      {{ templateTypeLabelKey(item.type) | translate }}
                    </span>
                  </div>
                </button>
              }
            }
          </div>
          @if (listBusy) {
            <div class="dc-list-syncing dc-list-syncing--sidebar" aria-busy="true">
              <mat-spinner diameter="28"></mat-spinner>
            </div>
          }
        </div>
      </div>

      <div class="dc-section dc-main">
        @switch (mainPhase) {
          @case ("boot") {
            <div class="dc-section__content dc-empty-wrap">
              <div class="dc-empty-state dc-empty-state--syncing">
                <mat-spinner diameter="36"></mat-spinner>
                <p>{{ "printCards.syncing" | translate }}</p>
              </div>
            </div>
          }
          @case ("empty") {
            <div class="dc-section__content dc-empty-wrap">
              <div class="dc-empty-state">
                <mat-icon>contact_page</mat-icon>
                @if (canManageTemplates) {
                  <button mat-raised-button color="primary" (click)="createTemplate()">
                    <mat-icon>add</mat-icon>
                    {{ "printCards.addFirstTemplate" | translate }}
                  </button>
                } @else {
                  <p>{{ "printCards.noTemplates" | translate }}</p>
                }
              </div>
            </div>
          }
          @default {
          @if (selected) {
          @if (mainReady) {
          <div class="dc-section__header dc-main-header">
            <div class="dc-title-row">
              <h2 class="dc-section__title">{{ selected.name }}</h2>
              <div class="dc-title-flags">
                @if (selected.isPendingApproval) {
                  @if (canApproveSelected) {
                    <button
                      type="button"
                      class="dc-title-active-button dc-title-active-button--active"
                      [disabled]="
                        approvalUpdatingTemplateId === selected.printCardTemplateId ||
                        activeUpdatingTemplateId === selected.printCardTemplateId ||
                        previewUpdatingTemplateId === selected.printCardTemplateId
                      "
                      (click)="approveTemplate(selected)"
                      [attr.aria-label]="
                        'printCards.pending.approveButton' | translate
                      "
                    >
                      @if (approvalUpdatingTemplateId === selected.printCardTemplateId) {
                        <mat-spinner
                          diameter="14"
                          class="dbc1-spinner dbc1-spinner--sm"
                        ></mat-spinner>
                      } @else {
                        <mat-icon>check</mat-icon>
                      }
                      {{ "printCards.pending.approveButton" | translate }}
                    </button>
                  }
                  @if (canRejectSelected) {
                    <button
                      type="button"
                      class="dc-title-active-button"
                      [disabled]="
                        approvalUpdatingTemplateId === selected.printCardTemplateId ||
                        activeUpdatingTemplateId === selected.printCardTemplateId ||
                        previewUpdatingTemplateId === selected.printCardTemplateId
                      "
                      (click)="rejectTemplate(selected)"
                      [attr.aria-label]="
                        'printCards.pending.rejectButton' | translate
                      "
                    >
                      @if (approvalUpdatingTemplateId === selected.printCardTemplateId) {
                        <mat-spinner
                          diameter="14"
                          class="dbc1-spinner dbc1-spinner--sm"
                        ></mat-spinner>
                      } @else {
                        <mat-icon>close</mat-icon>
                      }
                      {{ "printCards.pending.rejectButton" | translate }}
                    </button>
                  }
                  @if (canManageTemplates && !canApproveSelected && !canRejectSelected) {
                    <span class="dc-list-pending">
                      <mat-icon>hourglass_empty</mat-icon>
                      {{ "printCards.pending.badge" | translate }}
                    </span>
                  }
                } @else if (canManageTemplates) {
                  @if (selected.isActive) {
                    <button
                      type="button"
                      class="dc-title-active-button dc-title-active-button--active"
                      [disabled]="
                        activeUpdatingTemplateId === selected.printCardTemplateId ||
                        previewUpdatingTemplateId === selected.printCardTemplateId ||
                        approvalUpdatingTemplateId === selected.printCardTemplateId
                      "
                      (click)="setActive(selected, false)"
                      [attr.aria-label]="
                        'printCards.active.unsetActiveButton' | translate
                      "
                    >
                      @if (activeUpdatingTemplateId === selected.printCardTemplateId) {
                        <mat-spinner
                          diameter="14"
                          class="dbc1-spinner dbc1-spinner--sm"
                        ></mat-spinner>
                      } @else {
                        <mat-icon>check</mat-icon>
                      }
                      {{ "printCards.active.unsetActiveButton" | translate }}
                    </button>
                  } @else {
                    <button
                      type="button"
                      class="dc-title-active-button"
                      [disabled]="
                        activeUpdatingTemplateId === selected.printCardTemplateId ||
                        previewUpdatingTemplateId === selected.printCardTemplateId ||
                        approvalUpdatingTemplateId === selected.printCardTemplateId
                      "
                      (click)="setActive(selected, true)"
                      [attr.aria-label]="
                        'printCards.active.setActiveButton' | translate
                      "
                    >
                      @if (activeUpdatingTemplateId === selected.printCardTemplateId) {
                        <mat-spinner
                          diameter="14"
                          class="dbc1-spinner dbc1-spinner--sm"
                        ></mat-spinner>
                      } @else {
                        <mat-icon>star_outline</mat-icon>
                      }
                      {{ "printCards.active.setActiveButton" | translate }}
                    </button>
                  }
                  @if (selected.isPreview) {
                    <button
                      type="button"
                      class="dc-title-active-button dc-title-preview-button--active"
                      [disabled]="
                        activeUpdatingTemplateId === selected.printCardTemplateId ||
                        previewUpdatingTemplateId === selected.printCardTemplateId ||
                        approvalUpdatingTemplateId === selected.printCardTemplateId
                      "
                      (click)="setPreview(selected, false)"
                      [attr.aria-label]="
                        'printCards.preview.unsetPreviewButton' | translate
                      "
                    >
                      @if (previewUpdatingTemplateId === selected.printCardTemplateId) {
                        <mat-spinner
                          diameter="14"
                          class="dbc1-spinner dbc1-spinner--sm"
                        ></mat-spinner>
                      } @else {
                        <mat-icon>visibility</mat-icon>
                      }
                      {{ "printCards.preview.unsetPreviewButton" | translate }}
                    </button>
                  } @else {
                    <button
                      type="button"
                      class="dc-title-active-button"
                      [disabled]="
                        activeUpdatingTemplateId === selected.printCardTemplateId ||
                        previewUpdatingTemplateId === selected.printCardTemplateId ||
                        approvalUpdatingTemplateId === selected.printCardTemplateId
                      "
                      (click)="setPreview(selected, true)"
                      [attr.aria-label]="
                        'printCards.preview.setPreviewButton' | translate
                      "
                    >
                      @if (previewUpdatingTemplateId === selected.printCardTemplateId) {
                        <mat-spinner
                          diameter="14"
                          class="dbc1-spinner dbc1-spinner--sm"
                        ></mat-spinner>
                      } @else {
                        <mat-icon>visibility</mat-icon>
                      }
                      {{ "printCards.preview.setPreviewButton" | translate }}
                    </button>
                  }
                }
              </div>
            </div>
            <div class="dc-actions">
              @if (canManageTemplates) {
                <button type="button" (click)="editTemplate()" class="action-btn">
                  <mat-icon>edit</mat-icon>
                  {{ "edit" | translate }}
                </button>
                <button
                  type="button"
                  (click)="duplicateTemplate()"
                  [disabled]="duplicating"
                  class="action-btn"
                >
                  @if (duplicating) {
                    <mat-spinner diameter="18" class="dbc1-spinner dbc1-spinner--sm"></mat-spinner>
                  } @else {
                    <mat-icon>file_copy</mat-icon>
                  }
                  {{ "duplicate" | translate }}
                </button>
              }
              <button
                type="button"
                (click)="downloadPdf()"
                [disabled]="downloading || downloadingPrinter || downloadingAllEmployees"
                class="action-btn"
              >
                @if (downloading) {
                  <mat-spinner diameter="18" class="dbc1-spinner dbc1-spinner--sm"></mat-spinner>
                } @else {
                  <mat-icon>picture_as_pdf</mat-icon>
                }
                {{ "printCards.downloadPdf" | translate }}
              </button>
              <button
                type="button"
                (click)="downloadAllEmployeesPdf()"
                [disabled]="downloading || downloadingPrinter || downloadingAllEmployees"
                class="action-btn"
              >
                @if (downloadingAllEmployees) {
                  <mat-spinner diameter="18" class="dbc1-spinner dbc1-spinner--sm"></mat-spinner>
                } @else {
                  <mat-icon>picture_as_pdf</mat-icon>
                }
                {{ "printCards.downloadAllEmployeesPdf" | translate }}
              </button>
              @if (auth.isSuperAdmin) {
                <button
                  type="button"
                  (click)="downloadPrinterPdf()"
                  [disabled]="downloading || downloadingPrinter || downloadingAllEmployees"
                  class="action-btn"
                >
                  @if (downloadingPrinter) {
                    <mat-spinner diameter="18" class="dbc1-spinner dbc1-spinner--sm"></mat-spinner>
                  } @else {
                    <mat-icon>print</mat-icon>
                  }
                  {{ "printCards.downloadPrinterPdf" | translate }}
                </button>
              }
              @if (canManageTemplates && items.length > 0) {
                <button
                  type="button"
                  (click)="removeTemplate()"
                  [disabled]="deleting || !!selected?.hasOrders"
                  [attr.title]="
                    selected?.hasOrders
                      ? ('printCards.templateDeleteBlockedByOrders' | translate)
                      : null
                  "
                  class="action-btn action-btn--danger dc-action-delete"
                >
                  @if (deleting) {
                    <mat-spinner diameter="18" class="dbc1-spinner dbc1-spinner--sm"></mat-spinner>
                  } @else {
                    <mat-icon>delete_outline</mat-icon>
                  }
                  {{
                    (deleting ? "digitalCards.deleting" : "delete") | translate
                  }}
                </button>
              }
            </div>
          </div>
          }
          <div class="dc-section__content dc-preview-content">
            @if (!mainReady) {
              <div class="dc-preview-content-center">
                <div class="dc-empty-state dc-empty-state--syncing">
                  <mat-spinner diameter="36"></mat-spinner>
                  <p>{{ "printCards.syncing" | translate }}</p>
                </div>
              </div>
            } @else {
              <app-print-card-preview
                [frontDocumentHtml]="previewDocumentHtml"
                [backDocumentHtml]="previewBackDocumentHtml"
                [loading]="previewBusy"
                [pageWidthCm]="selectedPreviewPageWidthCm"
                [pageHeightCm]="selectedPreviewPageHeightCm"
              ></app-print-card-preview>
            }
          </div>
          }
          }
        }
      </div>
    </div>
  </div>
</div>
